<script setup>
import {RouterLink, RouterView} from 'vue-router'
</script>

<template>

  <RouterView/>

</template>

<script>
export default {
  name: "App",
  components: {},
}
</script>

<style scoped>

</style>